import React from "react";
import { useNavigate } from "react-router-dom";

import { UserContext } from "../../context/UserContext";
import { Head } from "../../utils/Head";
import { useForm } from "../../hooks/useForm";
import { Input } from "../../components/common/Input";
import { Button } from "../../components/common/Button";

const LoginPasswordLost = () => {
  const email = useForm("email");
  const { passwordReset } = React.useContext(UserContext);
  const navigate = useNavigate();

  async function handleSubmitLogin(event) {
    event.preventDefault();

    if (email.validate()) {
      passwordReset(email.value);
      navigate("/");
    }
  }
  return (
    <section>
      <Head title="Recuperar Senha" />
      <h1 className="title">Recuperar Senha</h1>
      <form action="" onSubmit={handleSubmitLogin}>
        <Input label="Email" type="email" name="email" {...email} />
        <Button>Enviar</Button>
      </form>
    </section>
  );
};

export default LoginPasswordLost;
